// App.js
import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";

import Wrapper from "./Shared/Wrapper";
import { Analytics } from "@vercel/analytics/react";
import { SpeedInsights } from "@vercel/speed-insights/react";
import Loading from "./components/Loading";

// Lazy load the components
const Home = React.lazy(() => import("./pages/Home"));
const Login = React.lazy(() => import("./pages/Login"));
const Schedual = React.lazy(() => import("./pages/Schedual"));

const App = () => {
  return (
    <BrowserRouter>
      <Wrapper>
        <Routes>
          <Route
            path="/"
            element={
              <React.Suspense fallback={<Loading />}>
                <Home />
              </React.Suspense>
            }
          />
          <Route
            path="/orari"
            element={
              <React.Suspense fallback={<Loading />}>
                <Schedual />
              </React.Suspense>
            }
          />
          <Route
            path="/login"
            element={
              <React.Suspense fallback={<Loading />}>
                <Login />
              </React.Suspense>
            }
          />
        </Routes>
      </Wrapper>
      <Analytics />
      <SpeedInsights />
    </BrowserRouter>
  );
};

export default App;
